export default {

    getFacilitiesUrl() { return `/facilities`; },
    getFacilityUrl(facilityId) { return `/facilities/${facilityId}/facility`; },

    getVersionUrl() { return '/version' }
}